// extracted by mini-css-extract-plugin
export var progressContainer = "_eg-0";